/**
 * Weglot custom language switcher.
 * DO NOT CHANGE HTML-TAGS. CHANGING THE HTML-TAGS CAN BROKE THE WIDGET.
 */

/* Weglot.initialize({
  api_key: drupalSettings.weglot,
}); */ // Add this back, if weglot is not initializing.

function createCurrentLangDiv(lang, langToFlag, ul) {
    var currentLang = document.createElement("div");
    currentLang.className = `wg-li ${lang} wgcurrent wg-flags`;
    currentLang.setAttribute("data-l", lang);
    currentLang.setAttribute("tabindex", "0");
    currentLang.setAttribute("role", "combobox");
    currentLang.setAttribute("aria-activedescendant", "");
    currentLang.setAttribute("aria-label", "Language Switcher");
    currentLang.setAttribute("aria-expanded", "false");
    currentLang.setAttribute("aria-controls", "weglot-listbox");

    var a = document.createElement("a");
    a.href = "#";
    a.id = `weglot-language-${lang}`;
    a.lang = lang;
    a.setAttribute("tabindex", "-1");
    a.setAttribute("target", "_self");

    var img = document.createElement("img");
    img.src = `https://cdn.weglot.com/flags/rectangle_mat/${langToFlag[lang] || lang}.svg`;
    img.width = 30;
    img.height = 20;
    img.setAttribute("role", "presentation");
    img.alt = "";
    img.className = "wg-flag";

    a.appendChild(img);
    a.appendChild(document.createTextNode(" " + Weglot.getLanguageName(lang)));
    currentLang.appendChild(a);

    // Show/hide languages.
    currentLang.addEventListener("click", function(e) {
        e.preventDefault();
        if (ul.style.display === "none") {
            ul.style.display = "block";
            currentLang.setAttribute("aria-expanded", "true");
        } else {
            ul.style.display = "none";
            currentLang.setAttribute("aria-expanded", "false");
        }
    });

    return currentLang;
}

// Init weglot switcher.
Weglot.on("initialized", async function() {
    let langToFlag = {};

    try {
        const response = await fetch('https://api.weglot.com/public/languages');
        const data = await response.json();
        data.forEach(lang => {
            let code = lang.code.toLowerCase();
            switch(code) {
                case 'en': code = 'gb'; break;
                case 'sv': code = 'se'; break;
                case 'ar': code = 'sa'; break;
            }
            langToFlag[lang.code] = code;
        });
    } catch (err) {
        console.error("Failed to fetch Weglot languages:", err);
    }

    document.querySelectorAll(".weglot-widget").forEach(function(container) {
        var availableLanguages = Weglot.options.languages
            .map(lang => lang.language_to)
            .concat(Weglot.options.language_from);

        var currentLang = Weglot.getCurrentLang();

        var switcherDiv = document.createElement("div");
        switcherDiv.className = "wg-dropdown";
        container.appendChild(switcherDiv);

        var ul = document.createElement("ul");
        ul.className = "wg-list";
        ul.style.display = "none"; // hide language list in the beginning.
        switcherDiv.appendChild(ul);

        var currentLang = createCurrentLangDiv(currentLang, langToFlag, ul);
        switcherDiv.insertBefore(currentLang, ul);

        // Dynamic languages.
        availableLanguages.forEach(function(lang) {
            if (lang === currentLang) return;

            var li = document.createElement("li");
            li.className = "wg-li wg-flags " + lang;

            var a = document.createElement("a");
            a.href = "#";

            var img = document.createElement("img");
            img.src = `https://cdn.weglot.com/flags/rectangle_mat/${langToFlag[lang] || lang}.svg`;
            img.width = 30;
            img.height = 20;
            img.className = "wg-flag";

            a.appendChild(img);
            a.appendChild(document.createTextNode(" " + Weglot.getLanguageName(lang)));

            a.addEventListener("click", function(e) {
                e.preventDefault();
                Weglot.switchTo(lang);

                // Repopulate current language.
                switcherDiv.removeChild(currentLang);
                currentLang = createCurrentLangDiv(lang, langToFlag, ul);
                switcherDiv.insertBefore(currentLang, ul);
                ul.style.display = "none";
            });

            li.appendChild(a);
            ul.appendChild(li);
        });

        // Update current language (updates all weglot switcher).
        Weglot.on("languageChanged", function(lang) {
            switcherDiv.removeChild(currentLang);
            currentLang = createCurrentLangDiv(lang, langToFlag, ul);
            switcherDiv.insertBefore(currentLang, ul);
            ul.style.display = "none";
        });
    });
});
